<template>
  <div></div>
</template>

<script>
import { createPopup } from '@typeform/embed';
import '@typeform/embed/build/css/popup.css';
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from '@/utils/eventTracker';
import { getTfForm, getTfResponse } from '@/services/typeform-api';
import getContext from '@/utilities/get-context.js';

export default {
  props: {
    typeformId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      toggle: () => {},
      form: null,
    };
  },
  computed: {
    clickSource() {
      return 'plForm';
    },
    currentUserId() {
      return this.$store.state.user?.id;
    },
  },
  mounted() {
    this.initTf();
  },
  methods: {
    initTf() {
      const { toggle } = createPopup(this.typeformId, {
        hidden: {
          geo_country: getContext().__MA__.user.visiting_country_name,
          geo_state: getContext().__MA__.user.visiting_state_name,
          ma_id: getContext().__MA__.user.id,
        },
        onQuestionChanged: this.trackQuestionChangedEvent,
        onReady: this.trackModalOpenEvent,
        onClose: this.trackFormClosedEvent,
        onSubmit: this.trackFormSubmittedAndAnswerReceivedEvents,
      });
      this.toggle = toggle;
    },

    getForm(formId) {
      if (this.form) {
        return Promise.resolve(this.form);
      }

      return getTfForm(formId).then(({ data: form }) => {
        this.form = form;
        return form;
      });
    },

    getQuestion(form, ref) {
      const formFields = {};
      form.fields.forEach(field => {
        formFields[field.ref] = field;
        if (field?.properties?.fields) {
          field?.properties?.fields.forEach(innerField => {
            formFields[innerField.ref] = innerField;
          });
        }
      });

      const question = formFields[ref];
      if (!question) {
        return {};
      }

      const questionNumber = Object.keys(formFields).findIndex(fieldRef => fieldRef === ref) + 1;

      return { ...question, questionNumber };
    },

    trackModalOpenEvent() {
      eventTracker(analyticsEvents.typeform.modalOpen, {
        trigger_button: 'Contact Sales',
        trigger_page: window.location.href,
      });
    },

    trackFormClosedEvent() {
      eventTracker(analyticsEvents.typeform.closed, {
        click_source: this.clickSource,
      });
    },

    trackQuestionChangedEvent({ formId, ref }) {
      this.getForm(formId).then(form => {
        const { title, questionNumber } = this.getQuestion(form, ref);
        eventTracker(analyticsEvents.typeform.questionChanged, {
          click_source: this.clickSource,
          question_number: questionNumber,
          question_title: title,
        });
      });
    },

    trackFormSubmittedAndAnswerReceivedEvents({ formId, responseId }) {
      this.trackFormSubmittedEvent();
      this.getForm(formId).then(form => {
        setTimeout(() => {
          getTfResponse(formId, responseId).then(({ data: response }) => {
            response.answers.forEach(item => {
              const { questionNumber, title: questionTitle } = this.getQuestion(
                form,
                item.field.ref,
              );
              let answer = '';
              switch (item?.type) {
                case 'choice':
                  answer = item?.choice?.label;
                  break;
                case 'choices':
                  answer = item?.choices?.labels?.join(', ');
                  break;
                case 'email':
                  answer = item?.email;
                  break;
                default:
                  answer = item?.text;
                  break;
              }
              this.trackAnswerReceivedEvent({
                questionTitle,
                questionNumber,
                answer,
              });
            });
          });
        }, 1000);
      });
      if (this.currentUserId) {
        this.$emit('typeFormSubmitted', true);
        this.toggle();
      }
    },

    trackFormSubmittedEvent() {
      eventTracker(analyticsEvents.typeform.submitted, {
        click_source: this.clickSource,
      });
    },

    trackAnswerReceivedEvent({ questionTitle, questionNumber, answer }) {
      eventTracker(analyticsEvents.typeform.answerReceived, {
        click_source: this.clickSource,
        question_title: questionTitle,
        question_number: questionNumber,
        answer,
      });
    },
  },
};
</script>
